import "./SectionSolicita.css";
import { useState, useEffect, useRef } from 'react';
import { motion, useInView } from "framer-motion";
import axios from "axios";
import { CATEGORIAS_API_URL } from "../../config/api";
import { useSectionScroll } from "../../hooks/useSectionScroll";

const botoes = [
    { id: 1, nome: "PODAGEM", icon: "icon-podagem", hover: "icon-podagem-b" },
    { id: 2, nome: "RETIRADA DE ENTULHO/LIXO", icon: "icon-limpeza-urbana", hover: "icon-limpeza-urbana-b" },
    { id: 3, nome: "TAPA BURACO", icon: "icon-tapa-buraco", hover: "icon-tapa-buraco-b" },
    { id: 4, nome: "ILUMINAÇÃO PÚBLICA", icon: "icon-iluminacao-publica", hover: "icon-iluminacao-publica-b" },
    { id: 5, nome: "CALÇAMENTO OU ASFALTAGEM", icon: "icon-asfalto", hover: "icon-asfalto-b" },
    { id: 6, nome: "ALAGAMENTO", icon: "icon-drenagem-de-ruas", hover: "icon-drenagem-de-ruas-b" },
    { id: 7, nome: "SUGESTÃO DE OBRAS OU REFORMAS", icon: "icon-sugestao", hover: "icon-sugestao-b" },
    { id: 8, nome: "TRÂNSITO", icon: "icon-transito", hover: "icon-transito-b" },
    { id: 9, nome: "CAPINAGEM", icon: "icon-capinagem", hover: "icon-capinagem-b" },
    { id: 10, nome: "OUTROS", icon: "icon-outros", hover: "icon-outros-b" },
];

const categoriasFallback = botoes.map(({ id, nome }) => ({ id, nome }));

export const SectionSolicita = ({ abrirModal, setAbrirModal, setCategoriaId, setCategoriaNome, currentRef, nextRef, prevRef }) => {
    const botaoRef = useRef(null);
    const isInView = useInView(botaoRef, { triggerOnce: true, threshold: 0.3 });
    const [comHover, setComHover] = useState(null);
    const [categorias, setCategorias] = useState([]);
    const [erroCategorias, setErroCategorias] = useState(false);
    const [carregandoCategorias, setCarregandoCategorias] = useState(true);

    useEffect(() => {
        let cancelado = false;
        axios.get(CATEGORIAS_API_URL, { withCredentials: false }).then(({ data }) => {
            if (cancelado) return;
            const lista = [data, data?.data, data?.categorias, data?.items, data?.results]
                .find(Array.isArray);
            if (!lista) throw new Error("Resposta de categorias inválida.");
            setCategorias(lista.length ? lista : categoriasFallback);
        }).catch(() => {
            if (!cancelado) {
                setCategorias(categoriasFallback);
                setErroCategorias(false);
            }
        }).finally(() => {
            if (!cancelado) setCarregandoCategorias(false);
        });
        return () => { cancelado = true; };
    }, []);

    useEffect(() => {
        if (currentRef.current) {
            if (abrirModal) {
                currentRef.current.style.filter = "blur(8px)";
                currentRef.current.style.pointerEvents = "none";
            } else {
                currentRef.current.style.filter = "none";
                currentRef.current.style.pointerEvents = "auto";
            }
        }
    }, [abrirModal, currentRef]);

    useSectionScroll({ currentRef, nextRef, prevRef, disabled: abrirModal });

    const aoClicar = (categoria) => {
        setCategoriaId(categoria.id);
        setCategoriaNome(categoria.nome);
        setTimeout(() => setAbrirModal(true), 50); // Delay para evitar conflito visual
    };

    return (
        <section className="container-section" ref={currentRef}>
            <div className="titulo-solicita">
                <div className="coluna-esquerda"></div>
                <h3 className="texto-solicita">Faça sua solicitação</h3>
                <div className="linha-direita"></div>
            </div>
            <div className="botoes" ref={botaoRef}>
                {carregandoCategorias && <p role="status">Carregando categorias...</p>}
                {erroCategorias && <p role="alert">Erro ao carregar categorias. Recarregue a página para tentar novamente.</p>}
                {!carregandoCategorias && !erroCategorias && categorias.length === 0 && <p>Nenhuma categoria disponível.</p>}
                {categorias.map((categoria, index) => {
                    const visual = botoes.find((item) => item.nome === categoria.nome?.toUpperCase()) ||
                        botoes.find((item) => item.id === categoria.id) || botoes[6];
                    const botao = { ...visual, id: categoria.id, nome: categoria.nome };
                    return (
                    <motion.button
                        key={botao.id}
                        onMouseEnter={() => setComHover(botao.nome)}
                        onMouseLeave={() => setComHover(null)}
                        initial={{ scale: 0, y: 5 }}
                        animate={isInView ? { scale: 1 } : { scale: 0 }}
                        transition={{ duration: 0.3 + index * 0.1, ease: "linear" }}
                        onClick={() => aoClicar(botao)}
                    >
                        <img
                            src={require(`../../assets/imagens/body-dois/icons/${comHover === botao.nome ? botao.hover : botao.icon}.png`)}
                            alt={`Ícone do botão de solicitação para ${botao.nome.toLowerCase()}`}
                            className="icons-botao"
                        />
                        <div className="descricao-do-botao">{botao.nome}</div>
                    </motion.button>
                    );
                })}
            </div>
        </section>
    );
};
